import { auth, doc, collection, db, onSnapshot } from '../../js/firebase.js'
import { useEffect, useState } from 'react';
import { RingLoader } from "react-spinners";
import { Cookies } from '../../index.js';
import axios from 'axios';
import ProfileNav from '../profiles/ProfileNav.jsx';
import Editcategory from '../products/Editcategory.jsx';
import { query, where, limit, getDocs } from 'firebase/firestore'
import { alert_error, alert_success } from '../../AppContext.js'
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'
import Description from './Description';
import Select from 'react-select';
import { RiPencilLine } from 'react-icons/ri';
import Profilebanner from './Profilebanner';
import Editshop from './Editshop';
function Editprofile() {
  const [inputlienket, setinputlienket] = useState('');
  const [nutxuly, setnutxuly] = useState(0);
  const [datatype, setdatatype] = useState('');
  const [theloai, settheloai] = useState('');
  const navigate = useNavigate();
  const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
  const [options, setOptions] = useState([
    { value: 'phone', label: 'Thay đổi số điện thoại', text: 'Nhập số điện thoại', placeholder: 'vd: 0367776906' },
    { value: 'lienket', label: 'Thay đổi địa chị liên hệ', text: 'Nhập liên kết liên hệ', placeholder: 'vd: https://zalo.me/0367776906' },
    { value: 'baohiem', label: 'Thêm Coins bảo hiểm', text: 'Nhập số Coins bảo hiểm, Coins càng cao thì bạn càng được hiện lên đầu danh sách ', placeholder: 'Số Coins dùng bảo hiểm cho khách' },
    { value: 'editshop', label: 'Chỉnh sửa mô tả', text: 'Đợi xíu ', placeholder: 'Đợi xíu' },
    { value: 'bluetick', label: 'Tích xanh tài khoản ', text: 'Chỉ 200 Coins profile của bạn sẽ có biểu tượng tích xanh giúp shop trở nên nổi bật tạo nên sự uy tín cho khách hàng', placeholder: 'Không cần nhập gì ' }
  ]);
  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutorder('đặt tiếp luôn nào')
    setnutxuly(0);
    if (status == 0) {
      alert_error(info.message);
    }
    else if (status == 1) {
      alert_success(info.message);
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  function handleSubmit(event) {
    setnutxuly(0);
    const apikey = Cookies.get('apikey');
    event.preventDefault();

    setnutxuly(1);
    setnutorder('Please wait a moment 😊');
    if (!inputlienket && theloai != 'bluetick') {
      alert('Please điền đầy đủ thông tin')
      setnutxuly(0);
      setnutorder('điền đủ thông tin');
      return
    }
    axios
      .post('https://hust.media/nosql/addservice.php', {
        lienket: inputlienket,
        key: apikey,
        chedo: 'editprofile',
        theloai: theloai,
      })
      .then(response => (testFunction(response)))
      .catch(error => console.log(error))

  }
  const [isOpen, setIsOpen] = useState(true);
  const [showeditshop, setshoweditshop] = useState(false);
  const handleChange = (selectedOption) => {
    setIsOpen(false);
    settheloai(selectedOption.value);
    setdatatype(selectedOption);
    if (selectedOption.value == 'editshop') {
      // navigate('/shop/editshop');
      setshoweditshop(true);
    }
    else {
      setshoweditshop(false);
    }
  };
  const handleFocus = () => {
    setIsOpen(true);
    console.log(123);
  };

  const handleBlur = () => {
    setIsOpen(false);
  };
  const handleMenuOpen = () => {
    setIsOpen(true);
  };
  const [user, setUser] = useState(null);
  const [shop, setshop] = useState(null);
  const [username, setusername] = useState(null);
  function laythongtin() {
    const myCookieValue = Cookies.get('apikey');
    const apidata = {
      apikey: myCookieValue,
      chedo: 'laythongtin',
      dulieu: 'shop',
    }
    const headers = {
      'Content-Type': 'application/json',
    }
    axios
      .post('https://hust.media/api/account.php', apidata, headers)
      .then((response) => {
        setshop(response.data);
        setusername(response.data.username);
        console.log(response.data.username);

      })
      .catch((error) => {
        alert_error(error)
      })
  }

  const getUserByUsername = async () => {
    const userRef = query(collection(db, 'users'), where('username', '==', username), limit(1))
    const unsubscribe = onSnapshot(userRef, (querySnapshot) => {
      if (!querySnapshot.empty) {
        const docSnapshot = querySnapshot.docs[0]
        setUser(docSnapshot.data())
        console.log(querySnapshot.docs[0].data())
      } else {
        console.log('No such document!')
        navigate('/reactapp/baohiem');
      }
    })
  }
  useEffect(() => {
    if (username) {
      getUserByUsername()
    }

  }, [username])
  useEffect(() => {
    laythongtin()
  }, [])
  return (
    <>
      {user ? (
        <div className='py-2 px-2'>
          <div className='grid grid-cols-1 md:grid-cols-1 gap-6'>
            <Profilebanner username={username} />
          </div>
          <div className='border-b border-gray-200 text-center font-medium text-gray-500 bg-slate-100 mt-2 py-3 px-2 rounded-sm'>
            <ProfileNav username={username} />

          </div>
          {window.location.pathname.startsWith("/shop/editprofile") ? (
            <div className='mx-auto  max-w-2xl'>
              <div className='border-b border-gray-200 text-center font-medium text-gray-500 bg-slate-100 mt-2 py-3 px-2 rounded-sm'>
                <div className='-mb-px flex flex-wrap p-0 gap-2'>
                  Sửa đổi
                  <form className="mx-auto add-form">
                    <div className="form-control">
                      <label>Chọn lựa chọn sửa đổi của bạn</label>
                      <Select
                        classNamePrefix="Chọn 1 lựa chọn"
                        onFocus={handleFocus}
                        options={options}
                        menuIsOpen={isOpen}
                        onBlur={handleBlur}
                        onMenuOpen={handleMenuOpen}
                        onChange={handleChange}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={false}
                      />
                    </div>
                    {showeditshop ? (
                      <>            <Editshop /></>) : (<>
                        {datatype && (

                          <>
                            <label className="mt-1"> {datatype.text} </label>
                            <br />
                            <div className="input-group flex-nowrap">
                              <span className="input-group-text" id="addon-wrapping">
                                <RiPencilLine />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={datatype.placeholder}
                                aria-label="inputlienket"
                                value={inputlienket}
                                name="inputlienket"
                                aria-describedby="addon-wrapping"
                                onChange={e => setinputlienket(e.target.value)}
                              />
                            </div>
                          </>
                        )}
                        <button disabled={nutxuly == 1} onClick={handleSubmit}
                          className='mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
                          <div className='flex items-center justify-between flex-1'>
                            {nutxuly == 1 &&
                              <div className="spinner-border" role="status">

                              </div>}


                            <span className='text-lg font-medium text-white'>
                              {nutorder}  </span>
                              <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                          </div>
                        </button>
                      </>)}
                  </form>


                </div>
              </div>  </div>)
            : window.location.pathname.startsWith("/shop/editcategory") ?
              (<><Editcategory/></>) : null}
          {user && (<>
            <Outlet context={[user]} />
            {console.log(user)}
          </>


          )}
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <RingLoader size={80} color="#0000ff" />  </div>
      )}
    </>
  )
}
export default Editprofile
